import { render, staticRenderFns } from "./localAdd.vue?vue&type=template&id=278a6344&"
import script from "./localAdd.vue?vue&type=script&lang=js&"
export * from "./localAdd.vue?vue&type=script&lang=js&"
import style0 from "./localAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports